/**
 * Creates a function for interpolating
 * @param translator
 * @returns
 */
export function createTranslationInterpolator(_options) {
    return function createInterpolations(variables) {
        return variables;
    };
}
//# sourceMappingURL=createTranslationInterpolator.js.map